// import './index.css'
import style from './Detainment.module.css'
import React,{useState} from 'react'
import { Modal } from 'antd-mobile'
// import DetainmentImg from '../../assets/img/推广-挽留页_03.png'
import imgEight from '../../assets/img/0.99_wanliutwo.png'
import imgNine from '../../assets/img/0.99_wanliutwo.png'


export default (porps) => {
  const [imgUrl] = useState(() => porps.sku_id == 1?imgNine:imgEight)
  return (
    <div>
      <Modal
       className="Detainment"
       visible={porps.visible}
       popup={false}
       transparent={true}
       maskClosable={true}
       onClose={porps.onClose}
      >
        <div className={style.DetainmentBox}>
          <div className={style.ImgBox}>
            <img src={imgUrl} alt=""/>
          </div>
          <div className={style.footer}>
            <div onClick={porps.leave}>
              真的就离开了？
            </div>
            <div onClick={porps.enter}>
              再进入支付页面
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}
